"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterFieldProvider = exports.optionsSourceShape = exports.optionShape = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _filters = require("../../../constants/filters");

var _actions = require("../../../store/filters/fields/actions");

var _treeChanges2 = _interopRequireDefault(require("tree-changes"));

var _FilterFormProvider = require("../FilterFormProvider");

var _FilterFieldWrapper = require("./FilterFieldWrapper");

var _selectors = require("../../../store/filters/options/selectors");

var _selectors2 = require("../../../store/filters/value/selectors");

var _actions2 = require("../../../store/filters/value/actions");

var _actions3 = require("../../../store/apiFlow/filterOptions/actions");

var _selectors3 = require("../../../store/filters/fields/selectors");

var _store = require("store");

var _component = require("../../../constants/component");

var _selectors4 = require("../../../store/apiFlow/filterOptions/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var optionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});
exports.optionShape = optionShape;
var optionsSourceShape = PropTypes.shape({
  url: PropTypes.string,
  mapping: PropTypes.func
});
exports.optionsSourceShape = optionsSourceShape;

var FilterFieldProvider = function FilterFieldProvider(WrappedComponent) {
  var _defineProperty2;

  var FilterFieldProvider =
  /*#__PURE__*/
  function (_Component) {
    _inherits(FilterFieldProvider, _Component);

    _createClass(FilterFieldProvider, [{
      key: "getStoredProps",
      value: function getStoredProps(props) {
        var _this2 = this;

        return _lodash["default"].pickBy(props, function (v, k) {
          return _lodash["default"].includes(_this2.storedProps, k);
        });
      }
    }, {
      key: "isStoredPropsChanged",
      value: function isStoredPropsChanged(props, nextProps) {
        var _treeChanges = (0, _treeChanges2["default"])(props, nextProps),
            changed = _treeChanges.changed;

        for (var i = 0; i < this.storedProps.length; i++) {
          if (changed(this.storedProps[i])) {
            return true;
          }
        }

        return false;
      }
    }, {
      key: "storedProps",
      get: function get() {
        return [_component.PROPS.FORM_ID, _component.PROPS.FIELD_NAME, _component.PROPS.FILTER_TYPE, _component.PROPS.DEFAULT_OPTIONS, _component.PROPS.IS_DEFAULT_FIRST_OPTION, _component.PROPS.IS_PRIMARY_FILTER, _component.PROPS.OPTIONS_SOURCE];
      }
    }]);

    function FilterFieldProvider(props) {
      var _this;

      _classCallCheck(this, FilterFieldProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterFieldProvider).call(this, props));
      var id = (0, _selectors3.getNextId)(_store.store.getState());
      _this.state = {
        id: id
      };
      props.create(id, _this.getStoredProps(props));
      return _this;
    }

    _createClass(FilterFieldProvider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var mount = this.props.mount;
        var id = this.state.id;
        mount(id, this.getStoredProps(this.props));
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var updateProps = this.props.updateProps;
        var id = this.state.id;

        if (this.isStoredPropsChanged(this.props, prevProps)) {
          updateProps(id, this.getStoredProps(this.props));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var id = this.state.id;
        var unmount = this.props.unmount;
        unmount(id);
      }
    }, {
      key: "render",
      value: function render() {
        var id = this.state.id;
        return _react["default"].createElement(_FilterFieldWrapper.FilterFieldWrapper, this.props, id && _react["default"].createElement(WrappedComponent, _extends({}, this.props, {
          id: id
        })));
      }
    }]);

    return FilterFieldProvider;
  }(_react.Component);

  _defineProperty(FilterFieldProvider, "propTypes", (_defineProperty2 = {}, _defineProperty(_defineProperty2, _component.PROPS.FORM_ID, PropTypes.number.isRequired), _defineProperty(_defineProperty2, _component.PROPS.FIELD_NAME, PropTypes.string.isRequired), _defineProperty(_defineProperty2, _component.PROPS.FILTER_TYPE, PropTypes.oneOf(_lodash["default"].values(_filters.FILTER_TYPE)).isRequired), _defineProperty(_defineProperty2, _component.PROPS.DEFAULT_OPTIONS, PropTypes.arrayOf(optionShape)), _defineProperty(_defineProperty2, _component.PROPS.IS_DEFAULT_FIRST_OPTION, PropTypes.bool), _defineProperty(_defineProperty2, _component.PROPS.IS_PRIMARY_FILTER, PropTypes.bool), _defineProperty(_defineProperty2, _component.PROPS.OPTIONS_SOURCE, optionsSourceShape), _defineProperty(_defineProperty2, "create", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "mount", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "unmount", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "updateProps", PropTypes.func.isRequired), _defineProperty2));

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      defaultOptions: props.options,
      options: (0, _selectors.getOptions)(state, props.filterType, props.fieldName),
      value: (0, _selectors2.getFieldValue)(state, props.filterType, props.fieldName),
      disableValue: (0, _selectors4.getIsDisabled)(state, props.filterType, props.fieldName)
    };
  };

  var mapDispatchToProps = {
    create: _actions.create,
    mount: _actions.mount,
    unmount: _actions.unmount,
    updateProps: _actions.updateProps,
    applyFilter: _actions2.apply,
    resetFilter: _actions2.reset,
    updateFilterField: _actions3.saga
  };
  return (0, _FilterFormProvider.FilterFormConsumer)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FilterFieldProvider));
};

exports.FilterFieldProvider = FilterFieldProvider;